/* AA Custom mega menu — mobile drawer controller.
   Desktop dropdown is pure CSS (:hover / :focus-within); this only drives the
   mobile drawer: open/close, ESC, scroll-lock, and auto-close when resizing up to
   the desktop breakpoint. Scoped to the <aa-mega-menu> custom element. */
(function () {
  'use strict';

  var DESKTOP = 1100;

  function init(root) {
    if (!root || root.dataset.aaMegaInit) return;
    root.dataset.aaMegaInit = 'true';

    var burger = root.querySelector('[data-aa-mega-open]');
    var drawer = root.querySelector('.aa-mega__m');
    var mViewport = root.querySelector('.aa-mega__m-viewport');
    var panel = root.querySelector('.aa-mega__panel');
    var veil = root.querySelector('.aa-mega__veil');

    // Relocate the dropdown surface, veil AND the mobile overlay to <body>. Inside the
    // header they sit under a frosted/transformed header, which is a "backdrop root":
    // it cancels their backdrop-filter (glass looks flat) and traps their position:fixed
    // to the header box. At <body> level their blur applies to the real page content and
    // fixed positioning is relative to the viewport. The overlay carries its own
    // .is-open (it's no longer a descendant of the .aa-mega root for CSS).
    if (panel) document.body.appendChild(panel);
    if (veil) document.body.appendChild(veil);
    if (drawer) document.body.appendChild(drawer);

    /* Pin the drawer's search + cart icons to the EXACT screen position of the real header
       icons, so they never shift when the nav opens. We measure each header icon's <svg>
       centre, then position the matching drawer element so ITS <svg> centre lands on the same
       point (measuring the drawer svg's own offset handles the cart's count-bubble width).
       The drawer is relocated to <body> and the header CSS can't reach it, so matching by
       measurement is the only reliable way. */
    function pinIcon(headerSvgSel, drawerEl) {
      if (!drawerEl) return;
      var hsvg = document.querySelector(headerSvgSel);
      var dsvg = drawerEl.querySelector('svg');
      if (!hsvg || !dsvg) { drawerEl.style.cssText = ''; return; }
      var h = hsvg.getBoundingClientRect();
      var targetX = h.left + h.width / 2, targetY = h.top + h.height / 2;
      // Park the element at 0,0 to read where its svg centre falls, then offset onto target.
      drawerEl.style.cssText = 'position:fixed;left:0;top:0;margin:0;padding:0;';
      var d = dsvg.getBoundingClientRect();
      drawerEl.style.left = (targetX - (d.left + d.width / 2)) + 'px';
      drawerEl.style.top = (targetY - (d.top + d.height / 2)) + 'px';
    }
    function syncRightIcons() {
      if (!drawer) return;
      /* AA: the drawer shows NO cart (hidden in CSS) — the search takes the cart's
         far-right header slot instead; falls back to the search icon's own position
         when the cart bubble is absent. */
      var target = document.querySelector('#cart-icon-bubble svg')
        ? '#cart-icon-bubble svg'
        : '#search-icon-open svg';
      pinIcon(target, drawer.querySelector('.aa-mega__m-search'));
    }
    function unpinRightIcons() {
      if (!drawer) return;
      var s = drawer.querySelector('.aa-mega__m-search'), c = drawer.querySelector('.aa-mega__m-cart');
      if (s) s.style.cssText = '';
      if (c) c.style.cssText = '';
    }

    function open() {
      root.classList.add('is-open');
      if (drawer) drawer.classList.add('is-open');
      if (veil) veil.classList.add('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      // Compensate for the vanishing scrollbar so the header/icons don't shift sideways when
      // scroll locks (the search icon was jumping a few px).
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      (window.requestAnimationFrame || window.setTimeout)(syncRightIcons);
    }

    function close() {
      root.classList.remove('is-open');
      if (drawer) drawer.classList.remove('is-open');
      if (veil) veil.classList.remove('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      unpinRightIcons();
      document.removeEventListener('keydown', onKey);
      resetDrill();
    }

    // Mobile drill-down: tapping a top-level link slides its Level-2 panel in from the
    // right (and Level 1 out to the left); Back slides Level 1 back in from the left.
    function openPanel(key) {
      if (!drawer) return;
      var target = drawer.querySelector('.aa-mega__m-l2[data-aa-m-panel="' + key + '"]');
      if (!target) return;
      drawer.querySelectorAll('.aa-mega__m-l2.is-active').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      target.classList.add('is-active');
      target.setAttribute('aria-hidden', 'false');
      if (mViewport) mViewport.classList.add('is-sub');
    }

    function resetDrill() {
      if (!drawer) return;
      drawer.querySelectorAll('.aa-mega__m-l2.is-active').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      drawer.querySelectorAll('.aa-mega__m-acc[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
      if (mViewport) mViewport.classList.remove('is-sub');
    }

    if (drawer) drawer.querySelectorAll('[data-aa-m-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openPanel(btn.getAttribute('data-aa-m-open'));
      });
    });
    if (drawer) drawer.querySelectorAll('[data-aa-m-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = btn.closest('.aa-mega__m-l2');
        if (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
          // Collapse this panel's accordions once it has slid out, so re-entering
          // starts with every Level-3 group closed (matches YSL).
          setTimeout(function () {
            p.querySelectorAll('.aa-mega__m-acc[open]').forEach(function (d) {
              d.removeAttribute('open');
            });
          }, 350);
        }
        if (mViewport) mViewport.classList.remove('is-sub');
      });
    });

    // Accordions: animate open/close with a slight ease, and keep only ONE open per
    // group (opening one collapses the currently-open sibling). We drive the native
    // <details> manually — preventDefault on the summary, then toggle `.open` around
    // a height transition (native <details> snaps instantly and allows many open).
    var EASE = 'height 0.28s ease';

    function expand(det, body) {
      det.open = true; // reveal content + flip chevron/bold via [open]
      body.style.overflow = 'hidden';
      body.style.height = '0px';
      void body.offsetHeight; // reflow so the next change animates
      body.style.transition = EASE;
      body.style.height = body.scrollHeight + 'px';
      body.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'height') return;
        body.removeEventListener('transitionend', onEnd);
        body.style.transition = '';
        body.style.height = '';
        body.style.overflow = '';
      });
    }

    function collapse(det, body) {
      body.style.overflow = 'hidden';
      body.style.height = body.scrollHeight + 'px';
      void body.offsetHeight;
      body.style.transition = EASE;
      body.style.height = '0px';
      body.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'height') return;
        body.removeEventListener('transitionend', onEnd);
        det.open = false; // hide content only AFTER the close animation
        body.style.transition = '';
        body.style.height = '';
        body.style.overflow = '';
      });
    }

    if (drawer) drawer.querySelectorAll('.aa-mega__m-accs').forEach(function (group) {
      group.querySelectorAll('.aa-mega__m-acc').forEach(function (det) {
        var head = det.querySelector('.aa-mega__m-acc-head');
        var body = det.querySelector('.aa-mega__m-acc-body');
        if (!head || !body) return;
        head.addEventListener('click', function (e) {
          e.preventDefault();
          if (det.open) {
            collapse(det, body);
          } else {
            group.querySelectorAll('.aa-mega__m-acc[open]').forEach(function (other) {
              if (other !== det) collapse(other, other.querySelector('.aa-mega__m-acc-body'));
            });
            expand(det, body);
          }
        });
      });
    });

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        close();
        closeMega();
      }
    }

    if (burger) {
      burger.addEventListener('click', function () {
        if (root.classList.contains('is-open')) close();
        else open();
      });
    }

    // The veil closes whatever is open (drawer on mobile, mega on desktop).
    if (veil) {
      veil.addEventListener('click', function () {
        close();
        closeMega();
      });
    }
    // The overlay's ✕ closer lives in the drawer (relocated to <body>), so bind it
    // there as well as any closer still inside the header root.
    root.querySelectorAll('[data-aa-mega-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    if (drawer) drawer.querySelectorAll('[data-aa-mega-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Drawer search: close the drawer, then open the header's existing search flyover
    // (the predictive-search modal toggle). If that toggle isn't present (search disabled
    // / on the search page), let the <a href="/search"> navigate normally.
    if (drawer) drawer.querySelectorAll('[data-aa-mega-search]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var toggle = document.getElementById('search-icon-open');
        if (toggle) {
          e.preventDefault();
          close();
          toggle.click();
        }
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= DESKTOP && root.classList.contains('is-open')) close();
      // Keep the glass height correct when columns reflow (no animation).
      if (root.classList.contains('is-mega-open')) setBgHeight(activeBgHeight(), false);
      // Re-pin the drawer search/cart to the header icons if the drawer is open.
      if (root.classList.contains('is-open')) syncRightIcons();
    });

    /* ---- Desktop dropdown: glass protracts/retracts, content stays anchored & fades ---- */
    var bar = root.querySelector('.aa-mega__bar');
    var bg = panel ? panel.querySelector('.aa-mega__bg') : null;
    var triggers = root.querySelectorAll('[data-aa-panel]');
    var groups = (panel || root).querySelectorAll('.aa-mega__group');
    var closeTimer = null;
    var openingTimer = null;
    var unfrostTimer = null;

    function activate(key) {
      groups.forEach(function (g) {
        g.classList.toggle('is-active', g.getAttribute('data-aa-group') === key);
      });
    }

    function activeBgHeight() {
      var g = panel && panel.querySelector('.aa-mega__group.is-active');
      // group.offsetTop = header height (its CSS top, measured in the panel); + its own
      // height → the glass spans the header AND the menu as ONE surface, and retracts
      // all the way to the page top.
      return g ? g.offsetTop + g.offsetHeight : 0;
    }

    // Animate (or instantly set) the glass layer's height. `animate` false = no transition
    // (used on resize so it snaps to the reflowed height).
    function setBgHeight(h, animate) {
      if (!bg) return;
      if (animate) {
        bg.style.height = h + 'px';
      } else {
        var prev = bg.style.transition;
        bg.style.transition = 'none';
        bg.style.height = h + 'px';
        void bg.offsetHeight; // force reflow so the next change can animate
        bg.style.transition = prev;
      }
    }

    function openMega(key) {
      cancelClose();
      if (unfrostTimer) { clearTimeout(unfrostTimer); unfrostTimer = null; }
      var wasOpen = panel && panel.classList.contains('is-open');
      activate(key);
      root.classList.add('is-mega-open'); // header CONTENT flip (custom-aa :has on the .aa-mega root)
      if (panel) {
        panel.classList.add('is-open'); // glass fades in + (height) protracts
        panel.setAttribute('aria-hidden', 'false');
      }
      if (!wasOpen) {
        // OPEN from closed: glass protracts DOWN (0 → height) + fades in; content is held
        // by the `.is-opening` delay and fades in once the glass is fully down.
        if (panel) panel.classList.add('is-opening');
        setBgHeight(activeBgHeight(), true);
        if (openingTimer) clearTimeout(openingTimer);
        openingTimer = setTimeout(function () {
          if (panel) panel.classList.remove('is-opening');
        }, 700);
      } else {
        // SWITCH while open: ease the glass height to the new group; content crossfades.
        setBgHeight(activeBgHeight(), true);
      }
    }

    function closeMega() {
      if (openingTimer) { clearTimeout(openingTimer); openingTimer = null; }
      if (panel) panel.classList.remove('is-open', 'is-opening'); // glass fades out...
      groups.forEach(function (g) { g.classList.remove('is-active'); }); // ...content fades out...
      setBgHeight(0, true); // ...and the glass retracts UP — all at the same time.
      if (panel) panel.setAttribute('aria-hidden', 'true');
      // Header CONTENT (root .is-mega-open) only flips back after the glass has gone.
      if (unfrostTimer) clearTimeout(unfrostTimer);
      unfrostTimer = setTimeout(function () {
        root.classList.remove('is-mega-open');
      }, 350);
    }

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function scheduleClose() {
      cancelClose();
      // Hover-intent delay so the surface survives the brief travel between the bar
      // and the panel (and any momentary mouseleave).
      closeTimer = setTimeout(closeMega, 200);
    }

    // Switch the active group as the cursor moves onto each trigger. The whole bar is
    // ONE hover region, so moving between links — including pausing in the gaps or over
    // childless links — never closes the surface; only LEAVING the bar does.
    if (bar) {
      bar.addEventListener('mouseover', function (e) {
        var trigger = e.target.closest('[data-aa-panel]');
        if (trigger) {
          openMega(trigger.getAttribute('data-aa-panel'));
        } else if (e.target.closest('.aa-mega__bar-link')) {
          // Hovering a parent link WITHOUT a dropdown closes the menu.
          scheduleClose();
        }
      });
      bar.addEventListener('mouseleave', scheduleClose);
    }

    // Keyboard: open the matching group when a trigger receives focus.
    triggers.forEach(function (t) {
      t.addEventListener('focus', function () {
        openMega(t.getAttribute('data-aa-panel'));
      });
    });

    // Keep the menu open while the cursor is over the dropdown content (the panel itself
    // is zero-height, so hover-tracking lives on the groups).
    groups.forEach(function (g) {
      g.addEventListener('mouseenter', cancelClose);
      g.addEventListener('mouseleave', scheduleClose);
    });

    // Keyboard: close when focus leaves the whole nav.
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) closeMega();
    });
  }

  function boot() {
    document.querySelectorAll('aa-mega-menu').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
